import React, { useState, useEffect } from 'react';
import './MonitoredIndividualThreadList.css';
import MonitoredIndividualThreadListItem from '../MonitoredIndividualThreadListItem/MonitoredIndividualThreadListItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logComponent from '../../common/logComponent';

export default function MonitoredIndividualThreadList({ monitoredIndividualThreadCollections, onSelect, fullWidth, selectedMonitoredIndividual }) {
  const [searchTerms, setSearchTerms] = useState('');
  const [visibleMonitoredIndividualThreadCollections, setVisibleMonitoredIndividualThreadCollections] = useState(monitoredIndividualThreadCollections);

  if (logComponent('MonitoredIndividualThreadList')) { console.debug('MonitoredIndividualThreadList rendered'); }

  useEffect(() => {
    if (logComponent('MonitoredIndividualThreadList')) { console.debug('MonitoredIndividualThreadList useEffect  [monitoredIndividualThreadCollections, searchTerms]'); }
    updateVisibleMonitoredIndividualThreadCollections();
  }, [monitoredIndividualThreadCollections, searchTerms])

  const updateSearchTerms = (e) => {
    if (logComponent('MonitoredIndividualThreadList')) { console.debug('MonitoredIndividualThreadList updateSearchTerms'); }
    setSearchTerms(e.target.value);
  }

  const updateVisibleMonitoredIndividualThreadCollections = () => {
    if (logComponent('MonitoredIndividualThreadList')) { console.debug('MonitoredIndividualThreadList updateVisibleMonitoredIndividualThreadCollections'); }

    let filteredMonitoredIndividualThreadCollections = monitoredIndividualThreadCollections.filter(collection => {
      let name1 = `${collection.monitoredIndividual.legalFirstName} ${collection.monitoredIndividual.lastName}`;
      let name2 = `${collection.monitoredIndividual.preferredFirstName} ${collection.monitoredIndividual.lastName}`;

      return name1.toLowerCase().includes(searchTerms.toLowerCase()) || name2.toLowerCase().includes(searchTerms.toLowerCase());
    });

    setVisibleMonitoredIndividualThreadCollections(filteredMonitoredIndividualThreadCollections);
  }

  const updateSelectedMonitoredIndividual = (monitoredIndividualThreadCollection) => {
    if (logComponent('MonitoredIndividualThreadList')) { console.debug('MonitoredIndividualThreadList updateSelectedMonitoredIndividual'); }
    onSelect(monitoredIndividualThreadCollection);
  }

  return (
    <div className={'Monitored-Individual-Thread-List' + (fullWidth ? ' Monitored-Individual-Thread-List--full-width' : '')}>
      <div className="Monitored-Individual-Thread-List__search-wrapper">
        <FontAwesomeIcon icon="search" className="Monitored-Individual-Thread-List__search-icon" />
        <input
          type="text"
          className="Monitored-Individual-Thread-List__search-input"
          placeholder="Search individuals"
          value={searchTerms}
          onChange={updateSearchTerms} />
      </div>
      <ul className="Monitored-Individual-Thread-List__monitoredindividuals">
        {
          visibleMonitoredIndividualThreadCollections.map(monitoredIndividualThreadCollection =>
            <MonitoredIndividualThreadListItem
              key={monitoredIndividualThreadCollection.monitoredIndividual.monitoredIndividualId}
              monitoredIndividualThreadCollection={monitoredIndividualThreadCollection}
              onClick={updateSelectedMonitoredIndividual}
              selected={!fullWidth ? monitoredIndividualThreadCollection.monitoredIndividual.monitoredIndividualId === selectedMonitoredIndividual.monitoredIndividualId : false} />
          )
        }
      </ul>
      {
        visibleMonitoredIndividualThreadCollections &&
        visibleMonitoredIndividualThreadCollections.length === 0 &&
        <p className="Monitored-Individual-Thread-List__empty-message">No individuals found...</p>
      }
    </div>
  );
}
